export default "__VITE_ASSET__kQP3EO7X__"